import { render, staticRenderFns } from "./Geoalert.vue?vue&type=template&id=f6e99cea"
import script from "./Geoalert.vue?vue&type=script&lang=js"
export * from "./Geoalert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports